import type { AdsPaginationState } from "@gumtree/shared/src/types/srp";

export const UPDATE_ADS_PAGINATION = 'UPDATE_ADS_PAGINATION';

const initialState = { firstPagePath: '', pagePath: '', numberOfPages: 0, currentPage: 0 };

export const updateAdsPagination = ({ firstPagePath, pagePath, numberOfPages, currentPage }) => ({
    type: UPDATE_ADS_PAGINATION,
    payload: { firstPagePath, pagePath, numberOfPages, currentPage },
});

export default (state: AdsPaginationState = initialState, action): AdsPaginationState =>
    action.type === UPDATE_ADS_PAGINATION ? { ...state, ...action.payload } : state;
